import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/client';
import { MenuItemDto } from '../../types';
import './Restaurant.css';

const RestaurantMenu: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [items, setItems] = useState<MenuItemDto[]>([]);
  const [showAdd, setShowAdd] = useState(false);
  const [newName, setNewName] = useState('');
  const [newPrice, setNewPrice] = useState('');
  const [newCategory, setNewCategory] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const res = await api.get(`/restaurants/${id}/menu`);
        setItems(res.data);
      } catch (err) {
        console.error('Failed to fetch menu', err);
      } finally {
        setLoading(false);
      }
    };
    fetchMenu();
  }, [id]);

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post(`/restaurants/${id}/menu-items`, {
        name: newName,
        price: parseFloat(newPrice),
        category: newCategory || undefined,
      });
      setShowAdd(false);
      setNewName('');
      setNewPrice('');
      setNewCategory('');
      alert('Menu item submitted for approval!');
    } catch (err: any) {
      alert(err.response?.data?.message || 'Failed to add item');
    }
  };

  const grouped = items.reduce((acc, item) => {
    const cat = item.category || 'Other';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(item);
    return acc;
  }, {} as Record<string, MenuItemDto[]>);

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Menu</h1>
        <button className="btn-primary btn-sm" onClick={() => setShowAdd(!showAdd)}>
          + Add Item
        </button>
      </div>

      {showAdd && (
        <form className="add-form" onSubmit={handleAdd}>
          <div className="form-group">
            <input placeholder="Item name *" value={newName} onChange={(e) => setNewName(e.target.value)} required />
          </div>
          <div className="form-group">
            <input placeholder="Price *" type="number" step="0.01" value={newPrice} onChange={(e) => setNewPrice(e.target.value)} required />
          </div>
          <div className="form-group">
            <input placeholder="Category" value={newCategory} onChange={(e) => setNewCategory(e.target.value)} />
          </div>
          <button type="submit" className="btn-primary btn-sm">Submit for Approval</button>
        </form>
      )}

      {loading ? (
        <p className="loading">Loading...</p>
      ) : items.length === 0 ? (
        <p className="empty">No menu items yet</p>
      ) : (
        Object.entries(grouped).map(([category, categoryItems]) => (
          <div key={category} className="menu-category">
            <h2 className="category-title">{category}</h2>
            <div className="menu-items">
              {categoryItems.map((item) => (
                <div key={item.id} className="menu-item-card">
                  <span className="item-name">{item.name}</span>
                  <span className="item-price">{item.price.toFixed(2)}</span>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default RestaurantMenu;
